
<template>
    <div>
        <van-swipe class="topSwipe" :autoplay="autoplayTime" indicator-color="white">
            <van-swipe-item v-for="(item, index) in imgs" :key="index" @click='clickImg(index)'>
                <img :class="className" :src="item" alt="" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
import {
    queryHomeTopBanner
} from "@/api/api";
import { isMiniprogram } from "@/libs/env";
export default {
    name: "Swipe",
    props: {
        areaType: Number,
        singleImg: String,
        className: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            autoplayTime: 5000,
            imgs: [],
            list: []
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            // 必传，广告投放区域。1、首页banner  2、地图 3、快捷缴费的banner 4、支付界面  5、泊位停车
            queryHomeTopBanner({
                areaType: this.areaType
            }).then((res) => {
                // res.data.length = 0
                if (res.data.length > 0) {
                    this.list = res.data
                    res.data.forEach((element) => {
                        this.imgs.push(element.imageUrl);
                    });
                } else {
                    this.imgs.push(this.singleImg);
                }
            });
        },
        clickImg(index) {
            if (this.list.length === 0) return

            let item = this.list[index]

            let appId = item.xcxID
            let xcxUrl = item.xcxUrl
            let h5Url = item.h5Url

            if (isMiniprogram()) {
                if (!appId || !xcxUrl) return
                wx.miniProgram.navigateTo({
                    url: `/pages/prizeDraw/prizeDraw?appId=${appId}&path=${encodeURIComponent(xcxUrl)}`,
                });
            }
            else {
                if (!h5Url) return
                window.location.href = h5Url
            }
        },
    },
};
</script>

<style scoped>
.topSwipe .van-swipe-item {
    color: #fff;
    text-align: center;
}
</style>